import React from 'react';
import styled from 'styled-components';
import { LinkOnComponent } from 'app/components/links/link';
import { LinkButton, LinkWrapper } from 'app/components/competitionModule/link/styles';
const StyledLink = styled(LinkOnComponent).withConfig({
  componentId: "sc-10u51jq-0"
})(["width:100%;"]);
export default function CompetitionModuleLink(_ref) {
  let {
    data
  } = _ref;
  const link = data.getSubrouteLink();
  if (!link) {
    return null;
  }
  return /*#__PURE__*/React.createElement(LinkWrapper, {
    "data-sentry-element": "LinkWrapper",
    "data-sentry-component": "CompetitionModuleLink",
    "data-sentry-source-file": "CompetitionModuleLink.tsx"
  }, /*#__PURE__*/React.createElement(StyledLink, {
    to: link.url,
    rel: link.rel,
    "data-sentry-element": "StyledLink",
    "data-sentry-source-file": "CompetitionModuleLink.tsx"
  }, /*#__PURE__*/React.createElement(LinkButton, {
    color: "inherit",
    variant: "text",
    "data-sentry-element": "LinkButton",
    "data-sentry-source-file": "CompetitionModuleLink.tsx"
  }, link.label)));
}